module.exports = __webpack_public_path__ + "static/media/img4.402f3897.jpg";